import { render } from "./WelcomeComponent.vue?vue&type=template&id=8668bb4a&scoped=true"
const script = {}

import "@/assets/styles/welcomecomponent.scss?vue&type=style&index=0&id=8668bb4a&scoped=true&lang=scss"

import exportComponent from "/home/djokic/Projects/mariv/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8668bb4a"]])

export default __exports__